import { Routes, Route, Navigate } from "react-router-dom";
import HomePage from "../pages/Home/components/Home.page";
import PointOfSale from "../pages/PointOfSale/components/PointOfSale.components";

const HomeRoutes: React.FC = () => {
  return (
    <Routes>
      <Route index element={<HomePage />} />
      <Route path="point-of-sale/:saleOption" element={<PointOfSale />} />
      <Route path="/*" element={<Navigate to="../" />} />
    </Routes>
  );
};

export default HomeRoutes;
